module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic large long modal",
    staticStyle: {
      "min-height": "99vh"
    },
    attrs: {
      "id": "productDetailModal"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.galleryPrevButton),
      expression: "galleryPrevButton"
    }],
    staticClass: "ui massive circular inverted basic icon button",
    staticStyle: {
      "position": "absolute",
      "top": "200px",
      "left": "-10%",
      "opacity": ".4"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.galleryPrev.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  })]), _vm._v(" "), (_vm.productIDs.length > 0) ? _c('div', {
    staticClass: "header prodDetOverlayHeader"
  }, [_c('i', {
    class: '' + (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace.toLowerCase().replace('uk', 'gb') : 'us') + ' flag'
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productUrl,
      "target": "_blank",
      "data-tooltip": "View Product On Amazon",
      "data-inverted": "",
      "data-position": "right center"
    }
  }, [_c('i', {
    staticClass: "blue external share icon"
  }), _vm._v("\n      " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productUrl ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productUrl.replace(/.*\/dp\/([a-zA-Z0-9]*)\?*.*/gi, "$1") : 'N/A') + "\n      -\n      " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productTitle))])]) : _vm._e(), _vm._v(" "), (_vm.productIDs.length > 0) ? _c('div', {
    staticClass: "content "
  }, [_c('div', {
    staticClass: "ui stackable grid",
    attrs: {
      "id": "muteAble"
    }
  }, [_c('div', {
    staticClass: "five wide column"
  }, [_c('div', {
    staticClass: "ui image"
  }, [(_vm.productIDs.length > 1 && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productGroupProductIds.length > 1) ? _c('div', {
    staticClass: "floating ui grey label",
    staticStyle: {
      "left": "93%"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.numInGroup()) + "  of  " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productGroupProductIds.length) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].isAdultFlag) ? _c('div', {
    staticClass: "floating ui big red label",
    staticStyle: {
      "left": "-2%",
      "top": "-5%"
    },
    attrs: {
      "data-tooltip": "!! Adult Item flag in ON - product does not appear on standard amazon search !!",
      "data-position": "right center"
    }
  }, [_c('i', {
    staticClass: "icon circle warning"
  }), _vm._v(" 18+\n            ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "ui image medium",
    staticStyle: {
      "max-height": "240px",
      "max-width": "240px",
      "height": "auto",
      "width": "auto",
      "border-radius": "3px"
    },
    attrs: {
      "src": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].largeImageUrl
    }
  })]), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].ageHours > -1) ? _c('div', [_c('br'), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].bsrRank !== null) ? _c('div', [_vm._v("\n            BSR "), _c('small', [_vm._v("(24h avg.): ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#a291fb",
      "font-weight": "bold"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].bsrRank) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui inverted segment",
    staticStyle: {
      "width": "275px",
      "border": "1px solid #333"
    }
  }, [_c('div', {
    staticClass: "ui inverted violet tiny statistic",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("today so far")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0].day : 'N/A') + " " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0] ? _vm.toMonth(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0].month) : '') + "    (" + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[0].unitsSold : 0))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted violet tiny statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1].day : 'N/A') + " " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1] ? _vm.toMonth(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1].month) : '') + "   (" + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].marketplace) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales && _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1] ? _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].sales[1].unitsSold : 0))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productGroupProductIds.length > 1) ? _c('div', [_c('div', {
    staticClass: "ui inverted brown tiny statistic"
  }, [_c('div', {
    staticClass: "label",
    staticStyle: {
      "visibility": "hidden",
      "height": "0"
    }
  }, [_vm._v("today so far")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.salesCount('t', _vm.productIDs[_vm.index], 'unitsSold')))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted brown tiny statistic"
  }, [_c('div', {
    staticClass: "label",
    staticStyle: {
      "visibility": "hidden",
      "height": "0"
    }
  }, [_vm._v("yesterday")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.salesCount('y', _vm.productIDs[_vm.index], 'unitsSold')))]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]) : _vm._e(), _vm._v(" "), _vm._l((['today', 'ytd']), function(day) {
    return _c('div', {
      staticStyle: {
        "width": "110px",
        "float": "left",
        "margin": "0 9px 1px 0"
      }
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasPromoCodes(day)),
        expression: "hasPromoCodes(day)"
      }],
      staticClass: "ui brown tiny tag label"
    }, [_vm._v("Promo codes")]), _vm._v(" "), _vm._l((_vm.promoCodes[day]), function(val, key) {
      return _c('small', {
        staticStyle: {
          "display": "block"
        },
        attrs: {
          "data-tooltip": key + ' : ' + val.units + ' units from ' + val.orders + ' orders',
          "data-position": "right center"
        }
      }, [(val.units !== val.orders) ? _c('span', [_vm._v("\n                   - " + _vm._s(key.slice(0, 25)) + ": "), _c('span', {
        staticStyle: {
          "color": "#fa5"
        }
      }, [_vm._v(" " + _vm._s(val.units))]), _vm._v(" ( from "), _c('span', {
        staticStyle: {
          "color": "#fa5"
        }
      }, [_vm._v(_vm._s(val.orders))]), _vm._v(" ord.)\n                ")]) : _c('span', [_vm._v("\n                   - " + _vm._s(key.slice(0, 25)) + ": "), _c('span', {
        staticStyle: {
          "color": "#fa5"
        }
      }, [_vm._v(" " + _vm._s(val.units) + " units")])])])
    }), _vm._v(" "), _c('small', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasPromoCodes(day)),
        expression: "hasPromoCodes(day)"
      }],
      staticStyle: {
        "color": "grey"
      }
    }, [_vm._v("\n                - no code:\n                  " + _vm._s(_vm.salesCount(day, _vm.productIDs[_vm.index], 'organicUnits')) + " u.\n                  (" + _vm._s(_vm.salesCount(day, _vm.productIDs[_vm.index], 'organicOrders')) + " ord.)\n              ")])], 2)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ui mini compact basic brown button",
    staticStyle: {
      "padding": "3px 6px",
      "font-size": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.$parent.$parent.$refs.chartModal.open(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]], 'productDetailModal')
      }
    }
  }, [_vm._v("\n              See full month...\n            ")])], 2), _vm._v(" "), (_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].fbaFeeEstimate !== null) ? _c('div', [_vm._v("\n            FBA Fee estimate: "), _c('span', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].fbaFeeEstimate) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("(based on current weight and size)")])]) : _vm._e()]) : _c('div', [_c('br'), _c('br'), _c('br'), _vm._v("\n            Syncing in progress."), _c('br'), _vm._v(" Sales and Promo-code data not yet available.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('h4', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_vm._v("Product Listing Health")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted relaxed divided list",
    staticStyle: {
      "margin-left": "0px"
    }
  }, _vm._l((_vm.wdDet), function(i) {
    return (_vm.currentProductWatchDogs[i.wdType]) ? _c('div', {
      staticClass: "item",
      class: {
        'muteAble': !_vm.currentProductWatchDogs[i.wdType].muted && (_vm.currentProductWatchDogs[i.wdType].status == 1 || _vm.currentProductWatchDogs[i.wdType].status == 2),
        'issueSt0': _vm.currentProductWatchDogs[i.wdType].issueStatus == 0,
        'issueSt1': _vm.currentProductWatchDogs[i.wdType].issueStatus == 1,
        'issueSt2': _vm.currentProductWatchDogs[i.wdType].issueStatus == 2,
        'issueSt3': _vm.currentProductWatchDogs[i.wdType].issueStatus == 3,
        'stts21kdfslds': (_vm.currentProductWatchDogs[i.wdType].status == 21)
      },
      attrs: {
        "data-wdtype": i.wdType
      }
    }, [(i.wdType == 'lostBuybox' && _vm.currentProductWatchDogs[i.wdType].statusDetails && _vm.currentProductWatchDogs[i.wdType].statusDetails.message && _vm.currentProductWatchDogs[i.wdType].statusDetails.message.indexOf('no offers from any sellers') >= 0) ? _c('i', {
      staticClass: "right grey warning circle icon"
    }) : _c('i', {
      class: _vm.getIconClasses(_vm.currentProductWatchDogs[i.wdType]),
      on: {
        "click": function($event) {
          return _vm.cycleIssueStatus(i.wdType, _vm.productIDs[_vm.index])
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "width": "100%",
        "color": "#8a8a8a"
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(_vm.currentProductWatchDogs[i.wdType].muted) ? _c('i', {
      staticClass: " mute alarm outline icon"
    }) : _vm._e(), _vm._v(" "), (!_vm.currentProductWatchDogs[i.wdType].muted && _vm.currentProductWatchDogs[i.wdType].status > 0) ? _c('span', [(_vm.currentProductWatchDogs[i.wdType].issueStatus == 1) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs[i.wdType].issueStatus == 2) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs[i.wdType].issueStatus == 3) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (i.wdType == 'badReview') ? _c('a', {
      attrs: {
        "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productReviewsUrl,
        "target": "_blank",
        "data-tooltip": "View The Latest Reviews On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    " + _vm._s(i.wdName) + " "), _c('i', {
      staticClass: "blue external share icon"
    })]) : (i.wdType == 'topReview') ? _c('a', {
      attrs: {
        "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productTopReviewsUrl,
        "target": "_blank",
        "data-tooltip": "View The Top Rated Reviews On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    " + _vm._s(i.wdName) + " "), _c('i', {
      staticClass: "blue external share icon"
    })]) : (i.wdType == 'lostBuybox') ? _c('a', {
      attrs: {
        "href": _vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]].productOffersUrl,
        "target": "_blank",
        "data-tooltip": "View All Offer For This ASIN On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    " + _vm._s(i.wdName) + " "), _c('i', {
      staticClass: "blue external share icon"
    })]) : (i.wdType == 'salesDrop') ? _c('span', [_vm._v("\n                    " + _vm._s(i.wdName) + "  \n                    "), _c('div', {
      staticClass: "ui brown compact basic icon button",
      staticStyle: {
        "float": "right",
        "margin": "1px"
      },
      on: {
        "click": function($event) {
          return _vm.$parent.$parent.$refs.chartModal.open(_vm.$parent.$parent.worldStore.products[_vm.productIDs[_vm.index]], 'productDetailModal')
        }
      }
    }, [_c('i', {
      staticClass: " large chart bar outline icon"
    })]), _vm._v(" "), (_vm.$parent.$parent.onboarding.saleschrt) ? _c('div', {
      staticClass: "onboarding ui right pointing large yellow label labelCursorFix",
      staticStyle: {
        "position": "absolute",
        "left": "160px",
        "cursor": "pointer"
      },
      attrs: {
        "data-onboarding": "saleschrt"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.$parent.$parent.onboarder('saleschrt')
        }
      }
    }, [_vm._v("\n                      Detailed Sales Chart + BSR"), _c('br'), _vm._v(" "), _c('small', {
      staticStyle: {
        "float": "right",
        "margin-top": "5px"
      }
    }, [_vm._v("Click this note to dismiss")])]) : _vm._e()]) : _c('span', [_vm._v("\n                    " + _vm._s(i.wdName) + "\n                  ")])]), _vm._v(" "), (i.wdType == 'topReview' || i.wdType == 'badReview') ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.prettyfyReviewText(_vm.currentProductWatchDogs[i.wdType].statusDetails.message))
      }
    }) : (i.wdType == 'starRatingRecentChange') ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.prettyfyRatingText(_vm.currentProductWatchDogs[i.wdType].statusDetails.message))
      }
    }) : _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.currentProductWatchDogs[i.wdType].statusDetails.message)
      }
    })])]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "five wide column"
  }, [(_vm.currentProductWatchDogs.inventory && _vm.currentProductWatchDogs.inventory.status !== 21) ? _c('div', {
    staticClass: "ui inverted segment",
    staticStyle: {
      "border": "1px solid #333"
    }
  }, [_c('h4', [_vm._v("FBA Stock level")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted relaxed list"
  }, [_c('div', {
    staticClass: "item inventoryItem",
    class: {
      'muteAble': !_vm.currentProductWatchDogs.inventory.muted && (_vm.currentProductWatchDogs.inventory.status == 1 || _vm.currentProductWatchDogs.inventory.status == 2),
      'issueSt0': _vm.currentProductWatchDogs.inventory.issueStatus == 0,
      'issueSt1': _vm.currentProductWatchDogs.inventory.issueStatus == 1,
      'issueSt2': _vm.currentProductWatchDogs.inventory.issueStatus == 2,
      'issueSt3': _vm.currentProductWatchDogs.inventory.issueStatus == 3
    }
  }, [_c('i', {
    staticClass: "big ",
    class: _vm.getIconClasses(_vm.currentProductWatchDogs.inventory),
    on: {
      "click": function($event) {
        return _vm.cycleIssueStatus('inventory', _vm.productIDs[_vm.index])
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message ? _vm.currentProductWatchDogs.inventory.statusDetails.message.replace(/\(.*\)/gi, '').replace(/(\d+)/gi, '<span style=\'color:white;\'>$1</span>') : '')
    }
  }), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message && _vm.currentProductWatchDogs.inventory.statusDetails.message.indexOf('No alert threshold') !== -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "data-tooltip": "You can set Inventory alerts on the 'FBA Stock' tab"
    }
  }, [_c('small', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v("[No FBA Inventory Alerts Set - hover for more]")])]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message && _vm.currentProductWatchDogs.inventory.statusDetails.message.toLowerCase().indexOf('(') > -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [(_vm.currentProductWatchDogs.inventory.muted) ? _c('i', {
    staticClass: " mute alarm outline icon"
  }) : _vm._e(), _vm._v(" "), ((!_vm.currentProductWatchDogs.inventory.muted) && _vm.currentProductWatchDogs.inventory.status > 0) ? _c('span', [(_vm.currentProductWatchDogs.inventory.issueStatus == 1) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.issueStatus == 2) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.inventory.issueStatus == 3) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.currentProductWatchDogs.inventory.statusDetails && _vm.currentProductWatchDogs.inventory.statusDetails.message ? _vm.currentProductWatchDogs.inventory.statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace('No alert threshold set; est', 'Est') : ''))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory && _vm.currentProductWatchDogs.fbmInventory.status !== 21) ? _c('div', {
    staticClass: "ui inverted segment",
    staticStyle: {
      "border": "1px solid #333"
    }
  }, [_c('h4', [_vm._v("FBM Stock level")]), _vm._v(" "), _c('div', {
    staticClass: "ui inverted relaxed list"
  }, [_c('div', {
    staticClass: "item fbmInventoryItem",
    class: {
      'muteAble': !_vm.currentProductWatchDogs.fbmInventory.muted && (_vm.currentProductWatchDogs.fbmInventory.status == 1 || _vm.currentProductWatchDogs.fbmInventory.status == 2),
      'issueSt0': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 0,
      'issueSt1': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 1,
      'issueSt2': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 2,
      'issueSt3': _vm.currentProductWatchDogs.fbmInventory.issueStatus == 3
    }
  }, [_c('i', {
    staticClass: "big ",
    class: _vm.getIconClasses(_vm.currentProductWatchDogs.fbmInventory),
    on: {
      "click": function($event) {
        return _vm.cycleIssueStatus('fbmInventory', _vm.productIDs[_vm.index])
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header",
    staticStyle: {
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message ? _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.replace(/\(.*\)/gi, '').replace(/(\d+)/gi, '<span style=\'color:white;\'>$1</span>') : '')
    }
  }), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.indexOf('No alert threshold') !== -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    },
    attrs: {
      "data-tooltip": "You can set Inventory alerts on the 'FBM Stock' tab"
    }
  }, [_c('small', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v("[No FBM Inventory Alerts Set - hover for more]")])]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.toLowerCase().indexOf('(') > -1) ? _c('div', {
    staticClass: "description",
    staticStyle: {
      "padding-top": "4px"
    }
  }, [(_vm.currentProductWatchDogs.fbmInventory.muted) ? _c('i', {
    staticClass: " mute alarm outline icon"
  }) : _vm._e(), _vm._v(" "), ((!_vm.currentProductWatchDogs.fbmInventory.muted) && _vm.currentProductWatchDogs.fbmInventory.status > 0) ? _c('span', [(_vm.currentProductWatchDogs.fbmInventory.issueStatus == 1) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.issueStatus == 2) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (_vm.currentProductWatchDogs.fbmInventory.issueStatus == 3) ? _c('small', {
    staticClass: "ui mini circular blue label",
    staticStyle: {
      "padding-top": ".8em !important",
      "min-height": "1em",
      "line-height": ".5em",
      "margin-right": "4px"
    }
  }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.currentProductWatchDogs.fbmInventory.statusDetails && _vm.currentProductWatchDogs.fbmInventory.statusDetails.message ? _vm.currentProductWatchDogs.fbmInventory.statusDetails.message.replace(/^[^(]*\(/, '').replace(/\)$/, '').replace('No alert threshold set; est', 'Est') : ''))])]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Primary Keywords Search Rank")]), _vm._v(" "), (_vm.currentProductKeywords.length > 0) ? _c('div', {
    staticClass: "ui inverted relaxed list",
    attrs: {
      "id": "keywordsList"
    }
  }, _vm._l((_vm.currentProductKeywords), function(k, i) {
    return _c('div', {
      key: k.watchDogItemId,
      staticClass: "item",
      class: {
        'muteAble': (k.status == 1 || k.status == 2) && !k.muted,
        'issueSt0': k.issueStatus == 0,
        'issueSt1': k.issueStatus == 1,
        'issueSt2': k.issueStatus == 2,
        'issueSt3': k.issueStatus == 3
      }
    }, [_c('i', {
      class: _vm.getIconClasses(k),
      on: {
        "click": function($event) {
          return _vm.cycleKeywordIssueStatus(_vm.productIDs[_vm.index], i)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "header"
    }, [(k.muted) ? _c('i', {
      staticClass: " mute alarm outline icon"
    }) : _vm._e(), _vm._v(" "), (!k.muted && (k.status == 1 || k.status == 2)) ? _c('span', [(k.issueStatus == 1) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Seen")]) : _vm._e(), _vm._v(" "), (k.issueStatus == 2) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("In Progress")]) : _vm._e(), _vm._v(" "), (k.issueStatus == 3) ? _c('span', {
      staticClass: "ui mini circular blue label",
      staticStyle: {
        "padding-top": ".8em !important",
        "min-height": "1em",
        "line-height": ".5em",
        "margin-right": "4px"
      }
    }, [_vm._v("Done")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": 'http://' + _vm.amaSites[k.marketplace] + '/s/?field-keywords=' + (k.settings && k.settings.keyword ? k.settings.keyword : ''),
        "target": "_blank",
        "data-tooltip": "View Keyword On Amazon",
        "data-inverted": "",
        "data-position": "right center"
      }
    }, [_vm._v("\n                    \"" + _vm._s(k.settings && k.settings.keyword ? k.settings.keyword : 'N/A') + "\"\n                    "), _c('i', {
      staticClass: "blue external share icon"
    })]), _vm._v(" "), (k.settings && k.settings.absoluteThreshold > 0 && k.settings.absoluteThreshold < 1000) ? _c('small', {
      staticStyle: {
        "color": "#aaa"
      },
      attrs: {
        "data-tooltip": 'Alert if rank falls below ' + k.settings.absoluteThreshold,
        "data-position": "top center"
      }
    }, [_vm._v("\n                    ("), _c('i', {
      staticClass: "right small alarm icon"
    }), _vm._v("< rank " + _vm._s(k.settings.absoluteThreshold) + ")\n                  ")]) : _vm._e(), _vm._v(" "), (k.hasOwnProperty('watchDogId')) ? _c('a', {
      staticClass: "removeKeyword",
      attrs: {
        "data-wdid": k.watchDogId,
        "data-tooltip": "Hold [Shift] + Click To Remove",
        "data-position": "top center"
      },
      on: {
        "click": function($event) {
          if (!$event.shiftKey) { return null; }
          $event.preventDefault();
          return _vm.removeKeyword(k.watchDogId)
        }
      }
    }, [_vm._v("Del Kwrd")]) : _vm._e()]), _vm._v("\n                " + _vm._s(k.statusDetails.message) + "\n              ")])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.showAddKeywordForm && _vm.currentProductKeywords.length < 8) ? _c('button', {
    staticClass: "ui mini compact basic labeled icon button teal",
    class: {
      'olive': _vm.currentProductKeywords.length == 0
    },
    staticStyle: {
      "position": "absolute"
    },
    on: {
      "click": function($event) {
        _vm.showAddKeywordForm = true
      }
    }
  }, [_c('i', {
    staticClass: "plus icon"
  }), _vm._v("Add\n          ")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAddKeywordForm),
      expression: "showAddKeywordForm"
    }],
    staticClass: "ui mini form",
    attrs: {
      "id": "addNewKeywordForm"
    }
  }, [_c('div', {
    staticClass: "eleven wide required field"
  }, [_c('input', {
    attrs: {
      "name": "newKeyword",
      "type": "text",
      "placeholder": "New Keyword Phrase To Track",
      "value": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline fields"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Alert if rank falls below this rank :  ")]), _vm._v(" "), _c('div', {
    staticClass: "three wide field",
    attrs: {
      "data-tooltip": "Rank 1-150 or leave blank for no Alerts",
      "data-position": "bottom center"
    }
  }, [_c('input', {
    attrs: {
      "name": "newTreshold",
      "type": "text",
      "placeholder": "Rank",
      "value": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui mini submit primary button",
    on: {
      "click": _vm.addNewKeyword
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('div', {
    staticClass: "ui mini button",
    on: {
      "click": function($event) {
        _vm.showAddKeywordForm = false
      }
    }
  }, [_vm._v("Cancel")])])])])], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._v("\n    hit ESC or click\n    "), _c('div', {
    staticClass: "ui inverted button",
    on: {
      "click": function($event) {
        return _vm.hide()
      }
    }
  }, [_vm._v("OK")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.galleryNextButton),
      expression: "galleryNextButton"
    }],
    staticClass: "ui massive circular inverted basic icon button",
    staticStyle: {
      "position": "absolute",
      "top": "200px",
      "right": "-10%",
      "opacity": ".4"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.galleryNext.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "right chevron icon"
  })]), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v("total in grp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "cube icon"
  }), _vm._v("units")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('small', [_vm._v("total in grp")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a623c22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails.vue
// module id = 767
// module chunks = 2